import * as angular from "angular";
export class hRoutes {
    static register(routes) {
        for (const route of routes) {
            let routeToAdd = {};
            let routeDependencies = route.route_dependencies || [];
            let routeStyles = [];
            if (route.route_styles && route.route_styles.styles) {
                routeStyles = route.route_styles.styles;
            }
            routeToAdd[route.url] = angular.copy(route);
            if (publicConfiguration.routes[route.url] && publicConfiguration.routes[route.url].route_dependencies) {
                routeDependencies = routeDependencies.concat(angular.copy(publicConfiguration.routes[route.url].route_dependencies));
            }
            if (publicConfiguration.routes[route.url] && publicConfiguration.routes[route.url].route_styles
                && publicConfiguration.routes[route.url].route_styles.styles) {
                routeStyles = routeStyles.concat(angular.copy(publicConfiguration.routes[route.url].route_styles.styles));
            }
            angular.merge(publicConfiguration.routes, routeToAdd);
            publicConfiguration.routes[route.url].route_dependencies = routeDependencies;
            if (routeStyles.length) {
                publicConfiguration.routes[route.url].route_styles.styles = routeStyles;
            }
        }
    }
}
//# sourceMappingURL=h-routes.js.map